// extracted by mini-css-extract-plugin
export default {"contentContainer":"client-groups-content_contentContainer__HlgAo"};